import React from "react"
import classnames from "classnames"
import Title from "./title"
import Card from "./card"
import * as styles from "../styles/scss/components/relatedArticlesBlock.module.scss"

const getImage = article => {
    const heroImage = article && article.heroImage
    const heroArticle = article && article.heroArticle
    const image = heroImage && heroImage.url ? heroImage : heroArticle

    if (!image || !image.url) return null

    return {
        url: image.relatedCardImageUrl || image.url,
        isPrebuilt: Boolean(image.relatedCardImageUrl),
    }
}

const normalizeRelatedArticle = article => {
    if (!article || !article.slug) return null

    const isUseArticle = article.__typename === "DatoCMS_UseArticleRecord"
    const subtitle = article.subtitle ? `: ${article.subtitle}` : ""
    const image = getImage(article)

    if (!image) return null

    return {
        id: article.id,
        slug: article.slug,
        title: `${article.title || ""}${subtitle}`,
        teaser: article.teaser,
        image: image.url,
        imageIsPrebuilt: image.isPrebuilt,
        link: isUseArticle ? `/useArticle/${article.slug}` : `/article/${article.slug}`,
    }
}

const RelatedArticlesBlock = ({ className = "", articles = [] }) => {
    const validArticles = (articles || [])
        .map(normalizeRelatedArticle)
        .filter(Boolean)

    if (validArticles.length === 0) {
        return null
    }

    return (
        <section className={classnames(className, styles.container)}>
            <Title titleType="h2" className={styles.title} value="RELATED ARTICLES" />
            <div className={styles.grid}>
                {validArticles.map(article => {
                    return (
                        <Card
                            key={article.id || article.link}
                            type="image"
                            title={article.title}
                            image={article.image}
                            link={article.link}
                            className={styles.card}
                            imgixWidth={500}
                            disableSrcSet={true}
                            rawImage={article.imageIsPrebuilt}
                            imgixParams={article.imageIsPrebuilt ? {} : {
                                fit: "crop",
                                crop: "focalpoint",
                                w: 500,
                                h: 780,
                                bri: -5,
                                auto: "format,compress",
                                q: 70,
                            }}
                            imageHtmlAttributes={{
                                width: 500,
                                height: 780,
                            }}
                        >
                            {article.teaser && <p>{article.teaser}</p>}
                        </Card>
                    )
                })}
            </div>
        </section>
    )
}

export default React.memo(RelatedArticlesBlock)
